import { useState, useRef, useCallback } from 'react';
import { GetToken } from '@utils/storage';
import * as config from '@config';

function useTransferEnquiryPost() {
    const [adding, setAdding] = useState(false);
    const abortRef = useRef();

    const addEnquiry = useCallback(async (req) => {
        setAdding(true);
        abort();
        abortRef.current = new AbortController();
        try {
            const response = await fetch(`${config.apiURL2}/transfer-enquiries`, {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${GetToken()}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(req),
                signal: abortRef.current.signal,
            });
            if (!response.ok) {
                const data = await response.json();
                throw new Error(data.error || 'An error occurred adding enquiry');
            }
            const data = await response.json();
            return data;
        } catch (error) {
            if (error.name === 'AbortError') {
                console.log('Request was aborted');
                throw new Error('Request was aborted');
            } else {
                console.error('Error adding enquiry:', error);
            }
            throw error;
        } finally {
            setAdding(false);
        }
    }, []);

    const abort = useCallback(() => {
        if (abortRef.current) {
            abortRef.current.abort();
        }
    }, []);

    return { adding, addEnquiry, abort };
}

export default useTransferEnquiryPost;
